<div class="login vh-100 d-grid">
  <div class="ap-flex flex-column">
    <div>
      <div class="brand p-3">
        <gstar-pwc-brand />
      </div>
    </div>
    <div class="ap-flex align-items-center justify-content-center flex-fill">
      <div class="ap-flex align-items-center flex-column title">
        <h1>
          <span class="d-block ap-text-gray ap-font-18">
            {{ 'login.h2' | translate }}
          </span>
          {{ 'login.h1' | translate }}
        </h1>
        <ap-button
          [label]="'login.loginButton' | translate"
          id="getstarted"
          class="mt-4"
          style="width: 100%"
          (onClick)="submitHandler()" />
      </div>
    </div>
    <div class="p-1">
      <gstar-footer #footer />
    </div>
  </div>
  <div class="background-image"></div>
</div>
<gstar-legal-disclaimer [(showDrawer)]="footer.showDisclaimer" />
